const pojemnoscSkokowa = { t: 'Pojemność skokowa', name: 'pojemnosc-skokowa', type: 'number', unit: 'cm³' }
export default pojemnoscSkokowa